import {
    ProductClient_V1,
    ProductItemSearchDTO,
    ProductItemDTO,
    CreateSalesOrderDTO,
    DealerSalesOrderDTO,
} from './generated/api.generated.v1';
import ApiConfig from './ApiConfig';
import { ApiHelper } from 'src/utils';

export default class ProductService {
    private readonly _productClient: ProductClient_V1;

    constructor() {
        this._productClient = new ProductClient_V1(new ApiConfig(), process.env.VUE_APP_API_V1_URL);
    }

    public Products(dealerAccountUid : string, dto: ProductItemSearchDTO): Promise<Array<ProductItemDTO>> {
        return this._productClient.productItems(dto, dealerAccountUid);
    }

    public TopProducts(dealerAccountUid : string, page : number, pageTake : number): Promise<Array<ProductItemDTO>> {
        return this._productClient.topProductItems(dealerAccountUid, page, pageTake);
    }

    public RecentlyOrderedProducts(dealerAccountUid : string, vin: string): Promise<Array<ProductItemDTO>> {
        return this._productClient.recentlyOrderedItems(dealerAccountUid, vin);
    }

    public ItemSubComponents(dealerAccountUid : string, itemId: string): Promise<Array<ProductItemDTO>> {
        return this._productClient.itemSubcomponents(dealerAccountUid, itemId);
    }

    public AlternateItem(dealerAccountUid : string, itemId: string, quantity: number): Promise<ProductItemDTO> {
        return this._productClient.alternateItem(dealerAccountUid, itemId, quantity);
    }

    public CreateSalesOrder(dealerAccountUid : string, dto : CreateSalesOrderDTO): Promise<DealerSalesOrderDTO> {
        return ApiHelper.ParseDTO<DealerSalesOrderDTO>(() =>this._productClient.createSalesOrder(dto, dealerAccountUid));
    }
}